import { createStore } from 'vuex'
import { auth } from '@/firebaseConfig'
import { User } from '@/models/user'

const store = createStore({
  state: {
    user: {} as User,
  },
  mutations: {
    setUserProfile(state, val) {
      state.user = val
    },
  },
  actions: {
    async logout({ commit }) {
      commit('setUserProfile', {})
      auth.signOut()
    },
    async setUserProfile({ commit }, user) {
      commit('setUserProfile', user)
    },
  },
})

export default store